import React from 'react';
import socialList from '../assets/socialsLinks';
import { Wrapper, SocialLink, SocialLinkWrapper, PlusButton } from '../styles/Socials';
import plus from '../assets/plus.svg';

const Socials = () => (
  <Wrapper notStatic clear fullWidth centerItems>
    {socialList.map(social => (
      <SocialLinkWrapper key={social.name}>
        <SocialLink href={social.link} target={social.target || ''}>
          <img src={social.image} alt={social.name} />
        </SocialLink>
      </SocialLinkWrapper>
    ))}
    <PlusButton clear>
      <img src={plus} alt="Open Links" />
    </PlusButton>
  </Wrapper>
);

export default Socials;
